async function getCart(url) {
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  });

  return response.json();
}

async function postAttributeNote(url, data) {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });

  return response.json();
}

async function getCJEFromServer(id) {
  const response = await fetch(`https://cj.nodnod.digital/session?id=${id}`, {
    headers: {
      'x-api-token': window.CJ_TOKEN?.signature,
      'x-api-timestamp': window.CJ_TOKEN?.timestamp,
    },
  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const data = await response.json();
  return data.value;
}

async function setCJEToServer(id, cjevent) {
  const response = await fetch(`https://cj.nodnod.digital/session?id=${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': window.CJ_TOKEN?.signature,
      'x-api-timestamp': window.CJ_TOKEN?.timestamp,
    },
    body: JSON.stringify({ value: cjevent }),
  });

  return response.ok;
}

async function handleCJEServer() {
  const cjeventCookie = getCookie('cje');
  const cjeventServer = getCookie('cje_server');
  const shopifySessionId = getCookie('_shopify_y');

  if (!shopifySessionId) return;

  if (cjeventCookie) {
    if (cjeventServer === '1') return;
    if (await setCJEToServer(shopifySessionId, cjeventCookie)) {
      setCookie('cje_server', '1');
    }
    return;
  }

  const cjeventServerValue = await getCJEFromServer(shopifySessionId);

  if (cjeventServer === '1') {
    if (cjeventServerValue) setCJConsent(cjeventServerValue);
    return;
  }

  if (!cjeventServer) {
    if (cjeventServerValue) {
      setCJConsent(cjeventServerValue);
      setCookie('cje_server', '1');
    } else {
      setCookie('cje_server', '0');
    }
  }
}

function isObjectEmpty(object) {
  for (var i in object) {
    return false;
  }

  return true;
}

function setCartAttributes(cartData, attributesToSet) {
  let attributesCodes = Object.keys(attributesToSet);
  let attributesToUpdate = {};

  attributesCodes.forEach((attributeCode) => {
    if (cartData.attributes[attributeCode] !== attributesToSet[attributeCode]) {
      attributesToUpdate[attributeCode] = attributesToSet[attributeCode];
    }
  });

  if (isObjectEmpty(attributesToUpdate)) {
    return;
  }

  postAttributeNote('/cart/update.js', {
    attributes: attributesToUpdate,
  });
}

function getCurrentUrlParameterValue(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i'),
    results = regex.exec(location.search);

  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getDomainName() {
  let domainName = location.hostname.replace(/^www\./i, '');

  if (domainName.endsWith('.slamjam.com')) {
    domainName = 'slamjam.com';
  }

  return domainName;
}

setCJConsent = (cjEvent) => {
  const now = new Date();
  const time = now.getTime();
  const expTime = time + 1000 * 34190000;
  now.setTime(expTime);

  document.cookie =
    'cje=' + cjEvent + '; expires=' + now.toGMTString() + '; secure' + '; path=/; domain=.' + getDomainName();
};

const handleCJEVENT = () => {
  let cjEvent = getCurrentUrlParameterValue('cjevent');

  if (!cjEvent) {
    handleCJEServer();
  }

  if (!cjEvent) {
    cjEvent = document.cookie
      .split('; ')
      .find((row) => row.startsWith('cje='))
      ?.split('=')[1];
  }

  if (!cjEvent) return;

  let utmSource = getCurrentUrlParameterValue('utm_source');
  let cjCampaign = 'row';

  if (utmSource.toLowerCase() == 'cj_us') {
    cjCampaign = 'us';
  }

  getCart('/cart.js').then((cartData) => {
    setCartAttributes(cartData, {
      cje: cjEvent,
      cjcampaign: cjCampaign,
    });
  });

  setCJConsent(cjEvent);
};

handleCJEVENT();
